import React, { createContext, useContext, useState } from "react";
import { toast } from "sonner";
import { DeleteConfirmDialog } from "@/components/DeleteConfirmDialog";
import { formatError } from "@/lib/api";

const AdminDeleteConfirmContext = createContext(null);

export const AdminDeleteConfirmProvider = ({ children }) => {
  const [pendingDelete, setPendingDelete] = useState(null);
  const [busy, setBusy] = useState(false);

  const requestDelete = (onConfirm) => {
    setPendingDelete({ onConfirm });
  };

  const cancelDelete = () => {
    if (!busy) setPendingDelete(null);
  };

  const confirmDelete = async () => {
    if (!pendingDelete) return;
    setBusy(true);
    try {
      await pendingDelete.onConfirm();
      setPendingDelete(null);
    } catch (error) {
      toast.error(formatError(error));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AdminDeleteConfirmContext.Provider value={{ requestDelete }}>
      {children}
      <DeleteConfirmDialog
        busy={busy}
        open={Boolean(pendingDelete)}
        onCancel={cancelDelete}
        onConfirm={confirmDelete}
      />
    </AdminDeleteConfirmContext.Provider>
  );
};

export const useAdminDeleteConfirmation = () => {
  const context = useContext(AdminDeleteConfirmContext);
  if (!context) {
    throw new Error("useAdminDeleteConfirmation must be used inside AdminDeleteConfirmProvider");
  }
  return context;
};